import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import StoreButtons from '../StoreButtons';

const HeroSection = () => (
  <section className="relative overflow-hidden bg-[#0F1419]" data-testid="hero-section">
    <div className="absolute inset-0 z-0">
      <img
        src="https://images.unsplash.com/photo-1724514415178-c87e1d00acd0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
        alt="Misty North American fly fishing river at dawn"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0F1419] via-[#0F1419]/90 to-[#0F1419]/60"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-[#0F1419] via-transparent to-[#0F1419]/40"></div>
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-16 lg:pt-16 lg:pb-24">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div className="text-center lg:text-left">
          <img
            src="https://customer-assets.emergentagent.com/job_fishing-companion-4/artifacts/66behbmm_noBgColor.png"
            alt="FlyFinder"
            className="h-20 md:h-24 w-auto mb-6 mx-auto lg:mx-0"
          />
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight leading-tight">
            Know What's Hatching<br />Before You Leave Home
          </h1>
          <p className="text-lg md:text-xl text-slate-300 mb-8 max-w-xl mx-auto lg:mx-0">
            FlyFinder is your AI-powered fly fishing companion. Real-time hatch data, weather analysis, and smart fly recommendations for your water &mdash; so you spend less time guessing and more time catching.
          </p>
          <StoreButtons center={false} className="mb-6 items-center lg:justify-start justify-center" />
          <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center lg:justify-start text-sm text-slate-400">
            <span>70+ fly patterns</span>
            <span className="text-[#137dc5]">&bull;</span>
            <span>7+ regions</span>
            <span className="text-[#137dc5]">&bull;</span>
            <span>Free to start</span>
          </div>
          <Link to="/fly-guide" className="inline-flex items-center gap-2 mt-6 text-[#3aa0e0] hover:text-white font-semibold transition-colors">
            Explore the Fly Guide
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="flex justify-center lg:justify-end">
          <div className="relative">
            <div className="absolute -inset-4 bg-[#137dc5]/20 blur-3xl rounded-full"></div>
            <img
              src="https://customer-assets.emergentagent.com/job_fishing-companion-4/artifacts/uuh0q985_fly1.JPG"
              alt="FlyFinder app showing personalized fly recommendations"
              className="relative w-full max-w-[300px] rounded-[2.5rem] border-4 border-[#1E2328] shadow-2xl"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;
